import { apiRequest } from "./api";

export interface EmployeeLoanSummary {
  hasActiveLoan: boolean;
  activeLoanAmount: number;
  pendingCount: number;
}

export interface EmployeeSummary {
  loan: EmployeeLoanSummary;
  leave: { pendingCount: number };
  payslip: {
    latest: {
      period: string;
      periodLabel: string;
      netPay: number;
      status: string;
    } | null;
  };
  tasks: { total: number; inProgress: number; todo: number };
  workAdjustments: { pendingCount: number };
}

export interface AdminSummary {
  loans: { pendingCount: number; approvedCount: number };
  leaves: { pendingCount: number };
  employees: { total: number; active: number; inactive: number };
  payslip: {
    currentPeriod: string;
    currentPeriodLabel: string;
    draftCount: number;
    finalizedCount: number;
  };
  cashAdvance: { pendingCount: number; approvedCount: number };
  wallet: {
    pendingEncashmentCount: number;
    approvedEncashmentCount: number;
    pendingAdvanceCount: number;
    approvedAdvanceCount: number;
  };
  tasks: { openCount: number };
  workAdjustments: { pendingCount: number };
}

export const summaryApi = {
  employee: () => apiRequest<EmployeeSummary>("/me/summary"),
  admin: () => apiRequest<AdminSummary>("/admin/summary"),
  bizAdmin: (businessId: string) =>
    apiRequest<AdminSummary>(`/biz/${businessId}/summary`),
};
